import gql from 'graphql-tag';

export const IMAGE_LINK_METADATA_FRAGMENT = gql`
  fragment imageLinkMetadata on ImageLinkMetadata {
    url
  }
`;
